export default __webpack_public_path__ + "static/media/diagnosis.bd2ee571.svg";